// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const getIdeasApiIdeasGetParamsSortDefault = `total`;
export const getIdeasApiIdeasGetParamsSortMax = 40;

export const getIdeasApiIdeasGetParamsOrderDefault = `desc`;
export const getIdeasApiIdeasGetParamsPageDefault = 1;

export const getIdeasApiIdeasGetParamsPageSizeDefault = 50;
export const getIdeasApiIdeasGetParamsPageSizeMax = 200;

export const getIdeasApiIdeasGetParamsIndustryItemMax = 40;

export const getIdeasApiIdeasGetParamsIndustryDefault = [];
export const getIdeasApiIdeasGetParamsIndustryMax = 50;

export const getIdeasApiIdeasGetParamsDispositionDefault = [];
export const getIdeasApiIdeasGetParamsDispositionMax = 3;

export const getIdeasApiIdeasGetParamsVerdictDefault = [];
export const getIdeasApiIdeasGetParamsVerdictMax = 5;

export const getIdeasApiIdeasGetParamsStatusOneMax = 40;

export const getIdeasApiIdeasGetParamsQOneMax = 200;

export const GetIdeasApiIdeasGetParams = zod.object({
  "sort": zod.string().max(getIdeasApiIdeasGetParamsSortMax).default(getIdeasApiIdeasGetParamsSortDefault),
  "order": zod.enum(['asc', 'desc']).default(getIdeasApiIdeasGetParamsOrderDefault),
  "page": zod.int().min(1).default(getIdeasApiIdeasGetParamsPageDefault),
  "page_size": zod.int().min(1).max(getIdeasApiIdeasGetParamsPageSizeMax).default(getIdeasApiIdeasGetParamsPageSizeDefault),
  "industry": zod.array(zod.string().max(getIdeasApiIdeasGetParamsIndustryItemMax)).max(getIdeasApiIdeasGetParamsIndustryMax).default(getIdeasApiIdeasGetParamsIndustryDefault),
  "disposition": zod.array(zod.enum(['active', 'parked', 'archived'])).max(getIdeasApiIdeasGetParamsDispositionMax).default(getIdeasApiIdeasGetParamsDispositionDefault),
  "verdict": zod.array(zod.enum(['go', 'conditional_go', 'no_go', 'researching', 'failed'])).max(getIdeasApiIdeasGetParamsVerdictMax).default(getIdeasApiIdeasGetParamsVerdictDefault),
  "status": zod.union([zod.string().max(getIdeasApiIdeasGetParamsStatusOneMax),zod.null()]).optional(),
  "q": zod.union([zod.string().max(getIdeasApiIdeasGetParamsQOneMax),zod.null()]).optional()
})

export type GetIdeasApiIdeasGetParams = zod.input<typeof GetIdeasApiIdeasGetParams>;
export type GetIdeasApiIdeasGetParamsOutput = zod.output<typeof GetIdeasApiIdeasGetParams>;
